import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../actions';
import { WEB3FORMS_ACCESS_KEY, WEB3FORMS_ENDPOINT } from '../config/web3forms';
import { showToast } from '../actions/toastBus';
import { LuSend } from 'react-icons/lu';
import '../stylesheet/style.css';
import '../stylesheet/Contact.css';

// Previously this posted through the EmailJS global script (window.emailjs)
// with a hardcoded 'default_service' and a template literally named
// 'Test' - Web3Forms replaces that with a single fetch call, no SDK, no
// template dashboard to keep in sync. The Firebase side (addMessage, the
// admin Inbox page) is untouched - that's still the source of truth for
// messages, this is only the "ping my email" notification.
class ContactForm extends Component {
    constructor(props) {
        super(props);
        this.state = { status: 'idle' };
        this.nameRef = React.createRef();
        this.emailRef = React.createRef();
        this.contactNoRef = React.createRef();
        this.messageRef = React.createRef();
    }

    resetFields = () => {
        if (this.nameRef.current) this.nameRef.current.value = '';
        if (this.emailRef.current) this.emailRef.current.value = '';
        if (this.contactNoRef.current) this.contactNoRef.current.value = '';
        if (this.messageRef.current) this.messageRef.current.value = '';
    }

    handleReset = () => {
        this.resetFields();
        this.setState({ status: 'idle' });
    }

    handleSubmit = async (event) => {
        event.preventDefault();
        const name = this.nameRef.current.value;
        const email = this.emailRef.current.value;
        const contactNo = this.contactNoRef.current.value;
        const message = this.messageRef.current.value;
        if (!name || !email || !message) return;

        this.setState({ status: 'sending' });

        // Save to the admin inbox regardless of how the email send below
        // goes - this is the reliable record, the email is just a heads-up.
        const createdAt = new Date().toString();
        this.props.addMessage({ name, email, contact: contactNo, message, createdAt });

        try {
            const response = await fetch(WEB3FORMS_ENDPOINT, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({
                    access_key: WEB3FORMS_ACCESS_KEY,
                    subject: `New portfolio message from ${name}`,
                    from_name: name,
                    name,
                    email,
                    phone: contactNo,
                    message,
                }),
            });
            const result = await response.json();
            if (!result.success) throw new Error(result.message || 'Web3Forms rejected the submission');

            this.setState({ status: 'idle' });
            this.resetFields();
            showToast("Message sent - I'll get back to you soon.", 'success');
        } catch (error) {
            console.error('Error sending contact email:', error);
            this.setState({ status: 'idle' });
            showToast('Could not send your message right now - please try again in a moment.', 'error');
        }
    }

    render() {
        const { status } = this.state;
        const isSending = status === 'sending';

        return (
            <div>
                <div className="backgroundLoader" style={{ visibility: isSending ? 'visible' : 'hidden' }}></div>
                <div className="loader" style={{ visibility: isSending ? 'visible' : 'hidden' }}>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <form onSubmit={this.handleSubmit} data-netlify="true">
                    <div className="app-form-group">
                        <input className="app-form-control" type="text" placeholder="NAME" ref={this.nameRef} name="name" required />
                    </div>
                    <div className="app-form-group">
                        <input className="app-form-control" type="email" placeholder="EMAIL" ref={this.emailRef} name="email" required />
                    </div>
                    <div className="app-form-group">
                        <input className="app-form-control" type="tel" placeholder="CONTACT NO" ref={this.contactNoRef} name="contactno" pattern="[0-9]{10}" maxLength="10" required />
                    </div>
                    <div className="app-form-group message">
                        <textarea className="app-form-control" placeholder="MESSAGE" ref={this.messageRef} name="message" rows={5} required />
                    </div>
                    <div className="app-form-group buttons">
                        <button className="app-form-button" type="submit" disabled={isSending}>
                            <LuSend /> {isSending ? 'Sending...' : 'Submit'}
                        </button>
                        <button className="app-form-button" type="button" onClick={this.handleReset} disabled={isSending}>
                            Reset
                        </button>
                    </div>
                </form>
            </div>
        );
    }
}

const mapStateToProps = ({ data }) => {
    return { data };
}

export default connect(mapStateToProps, actions)(ContactForm);
